import GenerateGatePass from "components/GatePass/generateGatePass";
import { GatePassTable } from "components/GatePass/passTable";
import { PassDetails } from "components/GatePass/passView";
import { ICard } from "components/Icard/Icard";
import { useEffect, useState } from "react";

export default function IcardComponent() {


  useEffect(() => {

  }, []);


  return (
    <div className="min-h-screen sm:px-6 lg:px-8">
      <ICard/>
    </div>
  );
}

